import React from 'react';
import { ListVariant } from '../../../_shared/types/trade';
import scrollToElementId from '../../../_shared/utils/scrollToElementId';

import ListSaleEventFooter from './ListSaleEventFooter';
import GridSaleEventFooter from './GridSaleEventFooter';

const SaleEventFooter = props => {
  const { listVariant, saleEventId } = props;

  const onJumpClickHandler = () => {
    if (listVariant !== ListVariant.GRID) {
      scrollToElementId(`saleEventHeader-${saleEventId}`);
    } else {
      scrollToElementId(`saleEventStart-${saleEventId}`);
    }
  };

  return listVariant !== ListVariant.GRID ? (
    <ListSaleEventFooter {...props} onJumpClick={onJumpClickHandler} />
  ) : (
    <GridSaleEventFooter {...props} onJumpClick={onJumpClickHandler} />
  );
};

export default SaleEventFooter;
